import * as React from 'react';
import * as styles from './About.css';

interface IAboutProps {
  aboutDeveloper: React.ReactNode;
  contacts: React.ReactNode;
  regions: React.ReactNode;
  reliable: React.ReactNode;
}

export const About: React.FC<IAboutProps> = ({ aboutDeveloper, regions, reliable, contacts }) => (
  <section id="about" className={styles['container']}>
    <div className={styles['wrapper']}>
      {contacts}
      {aboutDeveloper}
      {regions}
    </div>
    <div>{reliable}</div>
  </section>
);
